import React from 'react';
import cai from '../assets/cai.svg'; // Placeholder path for the CAI logo
import '../styles/App.css';

const AuthenticityBanner = () => {
  return (
    <div className="auth-container">
      {/* Left Section with Badge and Logo */}
      <div className="auth-left-section">
        <div className="auth-badge-label">
          <span className="auth-small-text">Official Member of</span>
        </div>
      </div>

      {/* Right Section with Description */}
      <div className="auth-right-section">
        {/* Placeholder for the main logo/text - adjust as needed */}
        <div className="auth-company-logo-placeholder">
          {/* You can replace this with an actual <img> tag */}
          <img src={cai} alt="CAI Logo" />
        </div>
        <p className="auth-description">
          <span className="auth-bold-text">ConRa</span> helps you prove exactly what's happening on-site. As a proud member of the <span className="auth-bold-text">Content Authenticity Initiative (CAI)</span>, we secure the integrity of the built environment. Using the global C2PA standard, we secure your project's 'digital twin' by locking every photo with your <span className="auth-bold-text">company's unique ID</span>. This prevents AI manipulation and unauthorized edits, ensuring your project data is always authentic and trusted.
        </p>
      </div>
    </div>
  );
};

export default AuthenticityBanner;